import type { CashOperationIdentityDto } from './cash-operation-identity.dto.js';

export const cashNeededRequestStatusValues = ['open', 'fulfilled', 'cancelled'] as const;
export type CashNeededRequestStatus = (typeof cashNeededRequestStatusValues)[number];

export interface CashNeededRequestDto extends CashOperationIdentityDto {
  id: string;
  storeId: string;
  locationId: string;
  stationId: string;
  cashLocationId: string;
  cashSessionId: string;
  requestedAmountMinor: number;
  note: string | null;
  status: CashNeededRequestStatus;
  createdByUserId: string;
  fulfilledByCashTransferId: string | null;
  fulfilledAt: string | null;
  fulfilledByUserId: string | null;
  cancelledAt: string | null;
  cancelledByUserId: string | null;
  cancellationReason: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCashNeededRequest {
  companyId: string;
  operationId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  cashLocationId: string;
  cashSessionId: string;
  requestedAmountMinor: number;
  note?: string | null;
  occurredAt?: string;
}

export interface CancelCashNeededRequest {
  companyId: string;
  operationId: string;
  requestId: string;
  reason?: string | null;
  occurredAt?: string;
}

export interface ListCashNeededRequestsRequest {
  companyId: string;
  locationId?: string;
  cashLocationId?: string;
  cashSessionId?: string;
  status?: CashNeededRequestStatus;
}

export interface ListCashNeededRequestsResponse {
  items: CashNeededRequestDto[];
}
